"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var placeholder = function placeholder(color) {
  return "\n  &::placeholder { color: ".concat(color, "; } \n");
};
var _default = exports.default = placeholder;